module.exports = __webpack_public_path__ + "img/form_text.7155b34e.png";